<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.60866 16.417C6.29199 15.6837 7.33366 15.742 7.93366 16.542L8.77533 17.667C9.45033 18.5587 10.542 18.5587 11.217 17.667L12.0587 16.542C12.6587 15.742 13.7003 15.6837 14.3837 16.417C15.867 18.0003 17.0753 17.4753 17.0753 15.2587V5.86699C17.0837 2.50866 16.3003 1.66699 13.1503 1.66699H6.85033C3.70033 1.66699 2.91699 2.50866 2.91699 5.86699V15.2503C2.91699 17.4753 4.13366 17.992 5.60866 16.417Z" stroke="url(#paint0_linear_7317_6716)" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M6.66699 5.83301H13.3337" stroke="url(#paint1_linear_7317_6716)" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M7.5 9.16699H12.5" stroke="url(#paint2_linear_7317_6716)" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
    <defs>
      <linearGradient id="paint0_linear_7317_6716" x1="0.663406" y1="-12.3394" x2="24.206" y2="-8.71694" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
      <linearGradient id="paint1_linear_7317_6716" x1="5.60586" y1="4.99273" x2="10.2217" y2="10.5671" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
      <linearGradient id="paint2_linear_7317_6716" x1="6.70415" y1="8.32671" x2="11.3795" y2="12.5614" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
    </defs>
  </svg>
</template>
